import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Leads() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [leads, setLeads] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user === false) { nav("/login"); return; }
    if (user && user.role === "admin") {
      api.get("/admin/leads").then((r) => setLeads(r.data)).catch(() => setError("Could not load leads."));
    }
  }, [user, nav]);

  if (user === null) return <div className="min-h-screen bg-ivory" />;
  if (user && user.role !== "admin") {
    return (
      <div className="min-h-screen bg-ivory text-ink">
        <Header variant="light" />
        <section className="pt-36 px-6 lg:px-10 max-w-3xl mx-auto">
          <p className="eyebrow mb-3">Restricted</p>
          <h1 className="font-display text-4xl tracking-tight">OWNER ACCESS ONLY</h1>
          <p className="mt-5 text-ink/60">This page is reserved for the House owner. <Link to="/" className="text-gold">Return home →</Link></p>
        </section>
      </div>
    );
  }

  const exportCsv = () => {
    const header = ["Created", "First name", "Last name", "Email", "Phone", "Interests", "Founding code", "Source page"];
    const body = leads.map((l) => [l.created_at, l.first_name || "", l.last_name || "", l.email, l.phone || "", (l.interests || []).join("; "), l.founding_code || "", l.source_page || ""]);
    const csv = [header, ...body].map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url; a.download = "luxewell-leads.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-ivory text-ink">
      <Header variant="light" />
      <section className="pt-36 pb-20 px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="eyebrow mb-3">The House · Leads</p>
            <h1 className="font-display text-4xl lg:text-5xl tracking-tight">INVITATION REQUESTS</h1>
            <p className="mt-3 text-sm text-ink/55">{leads.length} {leads.length === 1 ? "lead" : "leads"} captured.</p>
          </div>
          <button data-testid="export-csv" onClick={exportCsv} disabled={!leads.length}
            className="btn-lux bg-ink text-ivory hover:bg-gold hover:text-ink disabled:opacity-40">Export CSV</button>
        </div>
        {error && <p className="text-red-600 text-sm mb-6">{error}</p>}
        <div className="overflow-x-auto border border-gold/25">
          <table className="w-full text-sm" data-testid="leads-table">
            <thead>
              <tr className="text-left eyebrow !text-[0.55rem] text-ink/50 border-b border-gold/25">
                <th className="p-4">Date</th><th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Phone</th><th className="p-4">Interests</th><th className="p-4">Code</th><th className="p-4">Source</th>
              </tr>
            </thead>
            <tbody>
              {leads.length === 0 && <tr><td colSpan="7" className="p-6 text-ink/40">No leads yet.</td></tr>}
              {leads.map((l) => (
                <tr key={l.id} data-testid={`lead-row-${l.id}`} className="border-b border-gold/10 align-top">
                  <td className="p-4 text-ink/60 whitespace-nowrap">{(l.created_at || "").slice(0, 10)}</td>
                  <td className="p-4">{[l.first_name, l.last_name].filter(Boolean).join(" ") || "—"}</td>
                  <td className="p-4 text-ink/80">{l.email}</td>
                  <td className="p-4 text-ink/60">{l.phone || "—"}</td>
                  <td className="p-4 text-ink/60">{(l.interests || []).join(", ") || "—"}</td>
                  <td className="p-4 text-ink/60">{l.founding_code || "—"}</td>
                  <td className="p-4 text-ink/50">{l.source_page || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
